module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Prologue.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-19"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("PROLOGUE")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic",
    staticStyle: {
      "font-size": "1.76em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("B")]), _vm._v("ig Mike Parisi was the first-term governor of Connecticut and a dead man. He knew it even before he hit the water.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He couldn’t swim, an embarrassment not a half-dozen people knew.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His big, tough body belly-flopped into the water of his elegant pool and dropped hard and deep, hitting the blue-painted bottom that so beautifully reflected the summer sky. He managed to push up off the bottom and out of the water and yell for help.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can’t swim!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No help would come. His voice barely rose above the gurgling fountain halfway down the classic, kidney-shaped pool. His own damn fault. He’d refused to let his state trooper bodyguards out back with him. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("If I get stung by a bee, I’ll yell bloody murder. You’ll hear me. What the hell else could happen?")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Someone could try to kill him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d rented a house for the summer in Bluefield, a picturesque town in northwest Connecticut. Stockwell country. People assumed he wanted to be close to his lieutenant governor, Allyson Lourdes Stockwell, so they could strategize. The truth was, he was worried about her. Allyson had problems. Big problems.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Hadn’t occurred to Big Mike to worry about himself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Help!”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As he splashed and kicked, he saw the bluebird that he’d been trying to save. It was barely alive, soaked in the chlorinated water, slowly being sucked toward the pool filter.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They were both doomed, him and the bluebird. It was a juvenile, its feathers still speckled. It looked as if it had a broken leg. It couldn’t have been in the water long.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Clever. His death would look like an accident. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Michael Joseph Parisi drowned this afternoon in his swimming pool apparently while trying to rescue an injured bluebird…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Christ. He’d look like an idiot.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Some murdering son of a bitch had dumped the bird in the deep end, knowing he’d bend over and try to scoop it up. Bluebirds were his hobby, his passion since his wife died six years ago. They’d had no children. His desire to help restore the Eastern bluebird population in Connecticut and his personal interest in bluebirds weren’t a secret.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Not like not knowing how to swim. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("That")]), _vm._v(" was a secret. Hell, everyone knew how to swim.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His mother had regularly dumped his ass in the lake as a kid, trying to get him to learn. It didn’t work. She’d had to get his brother to fish him out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Was the bastard who’d planted the bluebird watching him flail and yell?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It’d look like a goddamn accident.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Rage consumed him, forced him up out of the water, yelling, swearing, pushing for the edge of the pool. It was so damn close. Why couldn’t he reach it? What the hell was he doing wrong? He could hear his mother yelling at him. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus, Mary and Joseph, Michael, you’re such a wienie. Swim, for the love of God.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("These days a mother like Marianne Parisi would be arrested for child abuse or put on pills or something. Total nutcase, his mother was, though she meant well. She died of a stroke when Mike was twenty-four, still thinking her second son would never amount to shit.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The pool water filled his nose and mouth, burned his eyes. He coughed, choking, taking in even more water. He couldn’t breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There’d be a lot of crocodile tears at his funeral.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Allyson would do fine as governor…")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Who the hell was he kidding? Allyson had her head in the sand. He’d tried to help her, and he knew that was why he was drowning now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Murdered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They’d have to cut him open. They’d find out he hadn’t hit his head or had a heart attack or a stroke. He’d "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("drowned.")]), _vm._v(" The autopsy wouldn’t pick up where he’d been poked in the ass. It’d felt like a stick or a pole or something. The pool was fenced in, but the deep end backed up to the woods. His murderer could have hid there and waited for Mike to come outside, then tossed in the bluebird when he had his back turned.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Easier to shoot him, but that wouldn’t have looked like an accident.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He stopped yelling. He stopped flailing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The faces of the living and the dead jumbled together in his head, and he couldn’t distinguish which was which, couldn’t tell which he was. Thoughts and memories, sounds came at him in a whirl. He could see bluebirds all around him, dozens of them, iridescent in the sunlight.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ah, Mike, you had it good….")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But all of that was done now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He prayed the way he’d learned in catechism class so long ago.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Hail Mary, full of grace, the Lord is with thee…")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His mother came into the bright light now, shaking her head, not with disgust this time, but with love and bemusement, as if she hadn’t expected him so soon. His wife was there, too, smiling as she had on their wedding day thirty years ago.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They held out their hands, and Big Mike laughed and walked toward his wife and his mother, and the bluebirds, into the light.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }), _c('p', {
    staticClass: "Basic-Paragraph-15"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a261788","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 69
// module chunks = 0